export default {
    /**
     * Convert the given value to a number.
     * @param input String input
     * @returns {*} Number or NaN
     */
    toNumber: function(input) {
        if (input === null || input === undefined || String(input).trim() === "") {
            return Number.NaN;
        } else {
            return Number(input);
        }
    },

    /**
     * Determine if the given value is undefined.
     * @param input Input
     * @returns {boolean}
     */
    isDefined: function(input) {
        return typeof input !== 'undefined'
    }
};